// API Configuration for Vulcan View Frontend

// Get API base URL from environment or use default
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://back-vulcanview.vulcanics.mx';

// API endpoints configuration
export const API_CONFIG = {
  baseURL: API_BASE_URL,
  endpoints: {
    health: '/api/health',
    workers: (pool) => `/api/workers/${pool}`,
    balance: (crypto) => `/api/balance/${crypto}`,
    earnings: (crypto) => `/api/earnings/${crypto}`,
    price: (crypto) => `/api/price/${crypto}`,
    scanner: '/api/scanner'
  },
  timeout: 30000
};

// Helper function to build full API URLs
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.baseURL}${endpoint}`;
};

// Available pools and cryptocurrencies
export const AVAILABLE_POOLS = ['litecoin', 'sha256'];
export const AVAILABLE_CRYPTOS = ['doge', 'bitcoin'];

export default API_CONFIG;